module.exports = require("./no.d.ts");